import React from 'react';
import { ActivityLog, ActivityLogEntry } from '@tviklax/ui-components';
import { ActivityLogProps } from './SchedulingContextTypes';

export const SchedulingActivityLog: React.FC<ActivityLogProps> = ({
  entries,
  isLoading = false,
}) => {
  const activityLogEntries: ActivityLogEntry[] = entries.map((entry) => ({
    id: entry.id,
    timestamp: entry.timestamp,
    type: entry.type === 'human' ? 'user' : 'system',
    actor: entry.actor,
    action: entry.action,
    details: entry.details,
  }));

  return (
    <ActivityLog
      entries={activityLogEntries}
      title="Activity Log"
      maxHeight="500px"
      isLoading={isLoading}
      emptyMessage="No activities logged yet"
    />
  );
};
